import React from 'react';
import { Space } from 'tdesign-react';
import UserDropdown from './UserDropdown';
import About from './About';

export default function RightOperations() {
  return (
    <Space align='center'>
      <About />
      <UserDropdown />
    </Space>
  );
}
